// NOTE: We limit the dpr/scale modification to avoid fetching too large images.
export const MAX_DPR_SETTING = 2;
